export type BaseUnit = 20;

export const baseUnit: BaseUnit = 20;
